import React from 'react';
import AssignmentRequests from "../../../components/AssignmentRequests/AssignmentRequests";
import ClinicsTable from "../../../components/ClinicsTable/ClinicsTable";


class ChainClinicsPage extends React.Component {
    render() {
        return (
            <div>
                <ClinicsTable/>
                <AssignmentRequests userType={3} />
            </div>
        );
    }
}


export default ChainClinicsPage;
